import React, { Fragment } from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import '../../../styles/itens.scss';


const Item = (props) => {
    return (
        <Fragment>
            <br/>
            <Row xs={2}>
                <Col xs={12} lg={10}>
                    <strong>{props.titulo}</strong><br/>
                    <p>{props.descricao}</p>
                </Col>
                <Col xs={12} lg={2}>
                    <a href={props.link} target='_blank'>
                        <Button variant='primary'>👉🏽 Acesse aqui</Button>
                    </a>
                </Col>
            </Row>
            <br />
            <hr />
        </Fragment>
    );
}

export default Item;